import React from "react";
import moment from "moment";
import Select from "react-select";

import NumberFormat from "react-number-format";
import { Button } from "react-bootstrap";
import { Scrollbars } from "react-custom-scrollbars";

import TableLoader, { TableColumn, TableRow } from "components/Table/Table.js";

import styles from "./style.module.css";

export default class RunRow extends React.PureComponent {
  render() {
    const { run, onClick, isHighlight, onHover, history } = this.props;

    return (
      <TableRow
        isHighlight={isHighlight}
        onMouseEnter={onHover ? () => onHover(run.id) : () => {}}
        onMouseLeave={onHover ? () => onHover(undefined) : () => {}}
      >
        <TableColumn>
          <a onClick={() => onClick()}>
            {run.setup && run.setup.label ? run.setup.label + " (" + run.id + ")" : run.id}
          </a>
        </TableColumn>
        <TableColumn title={moment.utc(run.createdDate).local().format("MMMM Do YYYY, h:mm:ss a")}>
          {moment.utc(run.createdDate).local().fromNow()}
        </TableColumn>
        <TableColumn>{run.runType}</TableColumn>
        <TableColumn>{run.isContinuous === true ? "Continuous" : "Categorical"}</TableColumn>
        <TableColumn>
          <div className={styles.capitalize}>{run.status ? run.status.toLowerCase() : ""}</div>
        </TableColumn>
        <TableColumn>
          {run.transformedModels && run.transformedModels.length > 0 ? run.transformedModels[0].label : "..."}
        </TableColumn>
        <TableColumn>
          {run.transformedModels && run.transformedModels.length > 0
            ? run.transformedModels[0].maxIteration.displayImpact
              ? Math.round(run.transformedModels[0].maxIteration.displayImpact)
              : Math.round(run.transformedModels[0].checkMax)
            : "..."}
        </TableColumn>
        <TableColumn>{run.createdBy}</TableColumn>
      </TableRow>
    );
  }
}
